'use client'; // Error components must be Client Components

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import imgError from 'public/images/ErrorImg.png';

import s from './index.module.scss';

import { Button } from '#/components/client';
import { Image } from '#/components/custom-image-loader';

export default function Error({
  error,
  // reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [err, setErr] = useState<null | {
    code: number;
    message: string;
    request_id: string;
  }>(null);
  const t = useTranslations();

  useEffect(() => {
    try {
      setErr(JSON.parse(error.digest || 'null'));
    } catch {
      setErr(null);
    }

    console.error(error);
    // TODO: add Slardar reporting for failed requests
  }, [error]);

  return (
    <div className={s.notFound}>
      <Image alt='request failed' src={imgError} priority />

      {err && (
        <>
          <h1>Request ID: {err?.request_id}</h1>
          <p>Code: {err?.code}</p>
          <p>Message: {err?.message}</p>
        </>
      )}
      <Link href='/'>
        <Button className={s.goHomeBtn} type='primary'>
          {t('home_btn')}
        </Button>
      </Link>
    </div>
  );
}
